<template>
  <div>
    <b-row class="match-height" align-h="center">
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="ServerIcon"
            color="danger"
            :statistic="nakamoto"
            statistic-title="Nakamoto Coefficient"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="CpuIcon"
            color="danger"
            :statistic="gini"
            statistic-title="Gini Coefficient"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="ActivityIcon"
            color="danger"
            :statistic="`${totStaked + ' Ⓝ'}`"
            statistic-title="Total NEAR Staked"
        />
      </b-col>
      <b-col md="10">
        <validators-active-set />
      </b-col>
    </b-row>
    <b-row class="match-height" align-h="center">
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="PercentIcon"
            color="danger"
            :statistic="avgStaked"
            statistic-title="Average Ⓝ Staked by Wallets"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="PercentIcon"
            color="danger"
            :statistic="medianStaked"
            statistic-title="Median Ⓝ Staked by Wallets"
        />
      </b-col>
    </b-row>
    <b-row class="match-height" align-h="center">
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="CalendarIcon"
            color="danger"
            :statistic="avgDuration"
            statistic-title="Average Staking Duration"
        />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal
            icon="CalendarIcon"
            color="danger"
            :statistic="medianDuration"
            statistic-title="Median Staking Duration"
        />
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col md="8">
        <net-staking />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { dFormatter } from '@/@core/utils/filter'
import axios from 'axios'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import ValidatorsActiveSet from './charts/ValidatorsActiveSet.vue'
import NetStaking from './charts/NetStaking.vue'

export default {
  components: {
    BRow,
    BCol,

    StatisticCardHorizontal,
    ValidatorsActiveSet,
    NetStaking,
  },
  data() {
    return {
      nakamoto: 0,
      gini: 0,
      totStaked: 0,
      avgStaked: 0,
      medianStaked: 0,
      avgDuration: 0,
      medianDuration: 0,
    }
  },
  methods: {
    dFormatter,
  },
  mounted() {
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/36ac7a37-2009-4ed3-9334-c80087eac6b3/data/latest')
    .then(response => {
      this.nakamoto = response.data[0].NAKA
      this.gini = response.data[0].GINI_COEFFICIENT
      this.totStaked = Intl.NumberFormat('en-US').format((response.data[0].TOT).toFixed(2))
    })
    .catch(e => {
      console.error(e)
    })   
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/31caa82b-8758-4458-979c-223a8cc37be2/data/latest')
    .then(response => {
      this.avgStaked = Intl.NumberFormat('en-US').format((response.data[0].AVG_STAKED).toFixed(2)) + ' Ⓝ'
      this.medianStaked = Intl.NumberFormat('en-US').format((response.data[0].MEDIAN_STAKED).toFixed(2)) + ' Ⓝ'
    })
    .catch(e => {
      console.error(e)
    }) 
    axios.get('https://node-api.flipsidecrypto.com/api/v2/queries/a05c7363-9ba9-4de4-85cd-7eb9926e0e13/data/latest')
    .then(response => {
      this.avgDuration = Intl.NumberFormat('en-US').format((response.data[0].AVG_DURATION).toFixed(2)) + ' Days'
      this.medianDuration = Intl.NumberFormat('en-US').format((response.data[0].MEDIAN_DURATION).toFixed(2)) + ' Days'
    })
    .catch(e => {
      console.error(e)
    })      
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>